'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utilities = require('@brandfolder/utilities');
var classnames = require('classnames');
var prismCore = require('prismjs/components/prism-core');
var React = require('react');
var Editor = require('react-simple-code-editor');
var styled = require('styled-components');
require('prismjs/components/prism-clike');
require('prismjs/components/prism-css');
require('prismjs/components/prism-javascript');
require('prismjs/components/prism-markup');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
var codeEditor = require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var useMounted = require('../../../../hooks/use-mounted.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var Editor__default = /*#__PURE__*/_interopDefaultCompat(Editor);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledBaseCodeEditor = (props)=>{
    const { className , defaultValue , id , ignoreTabKey =false , insertSpaces =true , language =codeEditor.CodeEditorLanguages.Css , onBlur , onChange , onEdit , padding =15 , sanitizeConfig , tabSize =2 , ...otherProps } = props;
    const [edit, setEdit] = React.useState({
        isSanitized: false,
        value: defaultValue || ''
    });
    const isMounted = useMounted.useMounted();
    React.useEffect(()=>{
        if (isMounted && onEdit) {
            onEdit(edit.value, edit.isSanitized);
        }
    }, [
        edit
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /*#__PURE__*/ React__default.default.createElement(Editor__default.default, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-code-editor': true,
            [`${className}`]: !!className
        }),
        highlight: (code)=>prismCore.highlight(code, prismCore.languages[language]),
        ignoreTabKey: ignoreTabKey,
        insertSpaces: insertSpaces,
        onBlur: (event)=>{
            const e = event;
            const sanitized = utilities.sanitize(e.target.value, sanitizeConfig);
            setEdit({
                isSanitized: e.target.value !== sanitized,
                value: sanitized
            });
            if (onBlur) onBlur(e);
        },
        onValueChange: (code)=>{
            setEdit({
                isSanitized: false,
                value: code
            });
            if (onChange) onChange(code);
        },
        padding: padding,
        tabSize: tabSize,
        textareaId: id,
        value: edit.value
    })));
};
// prismjs/themes/prism.css
const StyledCodeEditor = styled__default.default(UnstyledBaseCodeEditor)`
  code[class*='language-'],
  pre[class*='language-'] {
    color: black;
    background: none;
    text-shadow: 0 1px white;
    font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
    font-size: 1em;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }

  pre[class*='language-']::-moz-selection,
  pre[class*='language-'] ::-moz-selection,
  code[class*='language-']::-moz-selection,
  code[class*='language-'] ::-moz-selection {
    text-shadow: none;
    background: #b3d4fc;
  }

  pre[class*='language-']::selection,
  pre[class*='language-'] ::selection,
  code[class*='language-']::selection,
  code[class*='language-'] ::selection {
    text-shadow: none;
    background: #b3d4fc;
  }

  @media print {
    code[class*='language-'],
    pre[class*='language-'] {
      text-shadow: none;
    }
  }

  /* Code blocks */
  pre[class*='language-'] {
    padding: 1em;
    margin: 0.5em 0;
    overflow: auto;
  }

  :not(pre) > code[class*='language-'],
  pre[class*='language-'] {
    background: #f5f2f0;
  }

  /* Inline code */
  :not(pre) > code[class*='language-'] {
    padding: 0.1em;
    border-radius: 0.3em;
    white-space: normal;
  }

  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: slategray;
  }

  .token.punctuation {
    color: #999;
  }

  .token.namespace {
    opacity: 0.7;
  }

  .token.property,
  .token.tag,
  .token.boolean,
  .token.number,
  .token.constant,
  .token.symbol,
  .token.deleted {
    color: #905;
  }

  .token.selector,
  .token.attr-name,
  .token.string,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #690;
  }

  .token.operator,
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string {
    color: #9a6e3a;
    background: hsla(0, 0%, 100%, 0.5);
  }

  .token.atrule,
  .token.attr-value,
  .token.keyword {
    color: #07a;
  }

  .token.function,
  .token.class-name {
    color: #dd4a68;
  }

  .token.regex,
  .token.important,
  .token.variable {
    color: #e90;
  }

  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }

  .token.entity {
    cursor: help;
  }
`;
const BaseCodeEditor = (props)=>{
    return /*#__PURE__*/ React__default.default.createElement(StyledCodeEditor, _extends({}, props));
};

exports.BaseCodeEditor = BaseCodeEditor;
//# sourceMappingURL=base-code-editor.js.map
